import { combineReducers } from 'redux';
import userReducer from './user-reducer';
import uiReducer from './ui-reducer';
const rootReducer = combineReducers({
  userReducer, uiReducer
})

export default rootReducer;
